import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import { getLargeWindAuthor, getNewCarOnline, getGroupBuying } from '../../../../../services/api';
import SubTitle from '../../../components/subtitle';
import RightSeriesSearch from './rightSeriesSearch';
import Ad from '@ifeng/ui_pc_ad';
import rel from '../../../../../utils/rel';
import { handleAd } from '../../../../../utils/handleAd';
import errorBoundary from '@ifeng/errorBoundary';

class RightContent extends React.PureComponent {
    static propTypes = {
        content: PropTypes.object,
        curCity: PropTypes.object,
    };

    constructor(...argv) {
        super(...argv);
        this.state = {
            largeWindData: [],
            newCarData: [],
            groupBuyingData: [],
            changeCount: 0,
        };
    }

    async componentDidMount() {
        const largeWindData = await getLargeWindAuthor();
        const newCarData = await getNewCarOnline();
        const groupBuyingData = await getGroupBuying(
            this.props.curCity && this.props.curCity.citycode ? this.props.curCity.citycode : 110000,
        );

        this.setState({
            largeWindData,
            newCarData,
            groupBuyingData,
        });

        const { content } = this.props;

        const callbackFn = await handleAd(content.newcarIntroAd01);
        const callbackFn2 = await handleAd(content.newcarIntroAd04);

        callbackFn(this.refs.car_online_focus, content.newcarIntroAd01.data);
        callbackFn2(this.refs.car_online_div, content.newcarIntroAd04.data);
    }
    // 行业动态渲染
    ViewByIndustry(data) {
        const returnCarInfo = l => {
            return l.map((item, index) => {
                return (
                    <li key={index}>
                        <a href={item.url} target="_blank" rel={rel}>
                            {item.title}
                        </a>
                        <span>{item.newsTime.toString().substr(item.newsTime.length - 8, 5)}</span>
                    </li>
                );
            });
        };

        return (
            <div className={styles.mod} id="auto_p_8_4">
                <div className={styles.modinner}>
                    <div className={styles.dynamic}>
                        <SubTitle
                            content={{
                                title: '行业动态',
                                rightData: [{ name: '更多>>', url: '//auto.ifeng.com/hangye/' }],
                            }}
                        />
                        <div className={styles.mod_imgb}>
                            <ul className={styles.imgul_t}>{returnCarInfo(data)}</ul>
                            <div className={styles.clear} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
    // 团购渲染
    ViewByGroupBuying(data) {
        let myDate1 = data[0] && data[0].startdate ? new Date(data[0].startdate) : '';
        let myDate2 = data[1] && data[1].startdate ? new Date(data[1].startdate) : '';
        let myDate3 = data[2] && data[2].startdate ? new Date(data[2].startdate) : '';

        return (
            <div className={styles.mod} id="auto_p_8_3">
                <div className={styles.group_buy}>
                    <SubTitle
                        content={{
                            title: '团购',
                            middleData: [{ name: '往期', url: '//tuan.auto.ifeng.com/' }],
                            rightData: [
                                { name: '更多>>', url: `//tuan.auto.ifeng.com/${this.props.curCity.citypinyin}` },
                            ],
                        }}
                    />
                    <div className={styles.gb_con}>
                        {data[0] ? (
                            <div className={styles.gb_img_b}>
                                <div className={styles.img_b}>
                                    <a
                                        className={styles.img}
                                        href={`//tuan.auto.ifeng.com/${this.props.curCity.citypinyin}/tuan/${
                                            data[0].grouponid
                                        }`}
                                        target="_blank">
                                        <img alt="图片对应问题标题或者品牌车系车型" src={data[0].icon} />
                                    </a>
                                    <div className={styles.img_t}>
                                        <span className={styles.imgt_t}>
                                            <span className={styles.r}>[{this.props.curCity.cityname}]</span>
                                            <a
                                                href={`//tuan.auto.ifeng.com/${this.props.curCity.citypinyin}/tuan/${
                                                    data[0].grouponid
                                                }`}
                                                target="_blank">
                                                {data[0].grouponname}
                                            </a>
                                        </span>
                                        {myDate1 !== '' ? (
                                            <span className={styles.imgt_d}>
                                                时间：{myDate1.getFullYear()}-{myDate1.getMonth()}-{myDate1.getDate()}
                                            </span>
                                        ) : (
                                            ''
                                        )}
                                        <a
                                            className={styles.see_btn}
                                            href={`//tuan.auto.ifeng.com/${this.props.curCity.citypinyin}/tuan/${
                                                data[0].grouponid
                                            }`}
                                            target="_blank ">
                                            去看看
                                        </a>
                                    </div>
                                </div>
                                <div className={styles.img_w}>
                                    <span className={styles.t}>本期车型：</span>
                                    <span>{data[0].brandname}车型</span>
                                </div>
                            </div>
                        ) : (
                            ''
                        )}
                        <ul>
                            {data[1] ? (
                                <li>
                                    <span className={styles.r}>[钜惠]</span>
                                    <span className={styles.t}>
                                        <a
                                            href={`//tuan.auto.ifeng.com/${this.props.curCity.citypinyin}/tuan/${
                                                data[1].grouponid
                                            }`}
                                            target="_blank">
                                            {data[1].grouponname}
                                        </a>
                                    </span>
                                    {myDate2 !== '' ? (
                                        <span className={styles.d}>
                                            {myDate2.getFullYear()}-{myDate2.getMonth()}-{myDate2.getDate()}
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                </li>
                            ) : (
                                ''
                            )}

                            {data[2] ? (
                                <li>
                                    <span className={styles.r}>[特卖]</span>
                                    <span className={styles.t}>
                                        <a
                                            href={`//tuan.auto.ifeng.com/${this.props.curCity.citypinyin}/tuan/${
                                                data[2].grouponid
                                            }`}
                                            target="_blank">
                                            {data[2].grouponname}
                                        </a>
                                    </span>
                                    {myDate3 !== '' ? (
                                        <span className={styles.d}>
                                            {myDate3.getFullYear()}-{myDate3.getMonth()}-{myDate3.getDate()}
                                        </span>
                                    ) : (
                                        ''
                                    )}
                                </li>
                            ) : (
                                ''
                            )}
                        </ul>
                    </div>
                </div>
            </div>
        );
    }
    // 新车上市渲染
    ViewByNewCarOnline(data) {
        return (
            <div className={styles.box}>
                <div ref="car_online_div" className={styles.timeline_wrap}>
                    <div id="car_online_focus" ref="car_online_focus" className={styles.list}>
                        <div className={styles.info}>
                            <p>
                                <span className={styles.time}>{data[0].date.split('年')[1]}</span>
                            </p>
                        </div>

                        <div className={styles.pic}>
                            <a href={data[0].url} target="_blank" className={styles.placeholderimg}>
                                <div className={styles.txt}>
                                    <p className={styles.cname}>{data[0].cname}</p>
                                    <p className={styles.price}>{data[0].price}万</p>
                                </div>
                                <img
                                    width="80"
                                    height="60"
                                    src={data[0].img}
                                    className={styles.newonline_car_img}
                                    alt=""
                                />
                            </a>
                        </div>
                    </div>
                    {data &&
                        data.splice(1, 6).map((item, index) => (
                            <div id={`car_online_${index}`} className={styles.list} key={index}>
                                <div className={styles.info}>
                                    <p>
                                        <span className={styles.time}>{item.date.split('年')[1]}</span>
                                    </p>
                                </div>

                                <div className={styles.pic}>
                                    <a href={item.url} target="_blank" className={styles.placeholderimg}>
                                        <p className={styles.cname}>{item.cname}</p>
                                        <p className={styles.price}>
                                            指导价格：<span> {item.price}万</span>{' '}
                                        </p>
                                    </a>
                                </div>
                            </div>
                        ))}
                </div>
            </div>
        );
    }
    handleClickLargeWind(l) {
        const cycleNum1 = 5;
        let _largeWindData = l;
        let arr = _largeWindData.data;

        let delArr = arr.splice(0, parseInt(cycleNum1));

        _largeWindData.data = arr.concat(delArr);

        this.setState({
            largeWindData: Object.assign([], this.state.largeWindData, {
                largeWindData: _largeWindData,
            }),
        });
    }
    // 大凤号作者渲染
    ViewBylargeWind(l) {
        // 循环得个数
        const cycleNum = 5;

        // eslint-disable-next-line array-callback-return
        return l.data.map((item, index) => {
            if (index < cycleNum) {
                return (
                    <div key={index} className={styles.largewind_item_div}>
                        <div className={styles.img_div_1}>
                            <div className={styles.first_div}>
                                <div className={styles.img_div}>
                                    <img className={styles.largeWind_img} src={item.headimg} />
                                </div>
                                <div className={styles.img_div_word}>
                                    <ul>
                                        <li className={styles.autorli}>{item.name}</li>
                                        <li className={styles.descli}>{item.description}</li>
                                    </ul>
                                </div>
                            </div>
                            <a href={item.url_new ? item.url_new : item.url} target="_blank">
                                <div className={styles.tit_div}>{item.title}</div>
                            </a>
                        </div>
                        <div className={styles.img_div}>
                            <li className={styles.articlesli}>作品数：{item.articles}</li>
                        </div>
                    </div>
                );
            }
        });
    }

    // 工具查询入口渲染
    ViewByCarTool() {
        return (
            <div className={styles.modinner}>
                <div className={styles.tool}>
                    <ul>
                        <li>
                            <a className={styles.calculate} href="//car.auto.ifeng.com/jisuanqi/" target="_blank">
                                购车计算
                            </a>
                        </li>
                        <li>
                            <a
                                className={styles.contrast}
                                href="//car.auto.ifeng.com/series/compare.do"
                                target="_blank">
                                车型对比
                            </a>
                        </li>
                        <li>
                            <a className={styles.break} href="//auto.ifeng.com/weizhang/" target="_blank">
                                违章查询
                            </a>
                        </li>
                        <li>
                            <a
                                className={styles.insurance}
                                href="//car.auto.ifeng.com/jisuanqi/baoxian/"
                                target="_blank">
                                车险计算
                            </a>
                        </li>
                    </ul>
                    <div className={styles.clear} />
                    <i />
                </div>
                <div className={styles.u_enq}>
                    <div className={styles.uenq_tit}>实时询价 · 帮你寻找本地最低价</div>
                    <div className={styles.series_search}>
                        <RightSeriesSearch curCity={this.props.curCity} />
                    </div>
                </div>
            </div>
        );
    }

    /**
     * 渲染组件
     */
    render() {
        const { content } = this.props;

        return (
            <div className={styles.col_R}>
                {/* 大风号作者 */}

                {this.state.largeWindData.data && this.state.largeWindData.data.length > 0 ? (
                    <div className={styles.mod}>
                        <SubTitle
                            content={{
                                title: '大风号荣誉作者',
                                rightData: [{ name: '更多>>', url: '//auto.ifeng.com/quanmeiti/' }],
                            }}
                        />
                        <div className={styles.largewind_all_div}>{this.ViewBylargeWind(this.state.largeWindData)}</div>
                        <div className={styles.author_recom_title}>
                            <a target="_blank" onClick={() => this.handleClickLargeWind(this.state.largeWindData)}>
                                <i /> 换一换
                            </a>
                        </div>
                    </div>
                ) : (
                    ''
                )}

                <div className={styles.rectangle01}>
                    <Ad className={styles.rectangle01} content={content.rectangle01Ad} />
                </div>
                {/* 工具入口 */}
                <div className={styles.mod}>
                    <div className={styles.tool_enquiry}>{this.ViewByCarTool()}</div>
                </div>

                {/* 上市新车 */}
                {this.state.newCarData.data && this.state.newCarData.data.list.length > 0 ? (
                    <div className={styles.mod}>
                        <SubTitle
                            content={{
                                title: '上市新车',
                                middleData: [{ name: '本月', url: '//auto.ifeng.com/xinche/rili/' }],
                                rightData: [{ name: '更多>>', url: '//auto.ifeng.com/xinche/rili/' }],
                            }}
                        />
                        {this.ViewByNewCarOnline(this.state.newCarData.data.list)}
                    </div>
                ) : (
                    ''
                )}
                {/* 团购 */}
                {this.state.groupBuyingData && this.state.groupBuyingData.length > 0 ? (
                    <div>{this.ViewByGroupBuying(this.state.groupBuyingData)}</div>
                ) : (
                    ''
                )}
                {/* 行业动态*/}
                {content.industryNews && content.industryNews.length > 0 ? (
                    <div>{this.ViewByIndustry(content.industryNews)}</div>
                ) : (
                    ''
                )}
                <div className={styles.rectangle02}>
                    <Ad className={styles.rectangle02} content={content.rectangle02Ad} />
                </div>
            </div>
        );
    }
}

export default errorBoundary(RightContent);
